
import Typography from '@/ui-kit/components/typography';
import { TypographyType } from '@/ui-kit/components/typography/enums';
import { StyleColorSchemeType, StyleFontWeightType } from '@/ui-kit/styles/enums';
import { CHARGE_TYPE_BY_PREFIX } from './constants';
import { ChargeType } from './enums';

export default {
  components: {
    Typography,
  },
  props: {
    chargeValue: {
      default: null,
      type: Number,
    },
    chargeType: {
      default: null,
      type: String,
    },
  },
  data: () => ({
    TypographyType,
    StyleColorSchemeType,
    StyleFontWeightType,
  }),
  computed: {
    determinePriceInfo() {
      return CHARGE_TYPE_BY_PREFIX[this.chargeType] || ChargeType.ContactForQuote;
    },
    priceInfo() {
      return this.chargeType === ChargeType.ContactForPrice
        ? this.determinePriceInfo
        : `$${this.chargeValue + this.determinePriceInfo}`;
    },
  },

  methods: {
  },
};
